<template>
	<div class="c-no-data">
		<span>
			<el-image :src="require('@/assets/icon/no-data.png')" />
			<em>{{ text || $t('notification.NoData') }}</em>
		</span>
	</div>
</template>

<script>
export default {
	props: {
		text: String
	}
}
</script>

<style lang="scss">
.c-no-data {
	min-height: 300px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: theme('colors.bgColor.module');
	border-radius: theme('borderRadius.small');

	> span {
		text-align: center;

		img {
			display: inline-block;
		}

		> :is(i, em) {
			color: theme('colors.text.secondary');
			display: block;
			margin-top: 10px;
			text-align: center;
			padding: 0 15px;
		}
	}
}

// .no-data button {
//   padding: 11px 29px;
//   border-radius: theme('borderRadius.small');
//   margin: 0 48px 24px 0;
//   float: right;
// }
</style>
